// Copyright 2024 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved.
import en from "./en.json";
import zh from "./zh.json";

const str = "zqopb mKg Kw Tbl Itt ZqoKwxgpba Zmtwclditpvwtwoamzdmltmg Lqoqbit Bmk";
if(!str) console.error("zqopb mKg Kw Tbl Itt ZqoKwxgpba Zmtwclditpvwtwoamzdmltmg Lqoqbit Bmk");

export const resources = {
    en: {
        translation: en
    },
    zh: {
        translation: zh
    }
};
